import styled from 'styled-components';

export const item = styled.button<{$selected?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: var(--dimension-16, 64px);
    padding: 0 var(--space-xl);
    gap: var(--space-sm);
    background: transparent;
    border: none;
    border-top: 1px solid var(--color-border-subtle);
    cursor: pointer;
    text-align: ${({theme}) => (theme.rtl ? 'right' : 'left')};
    direction: inherit;

    &:first-child {
        border-top: none;
    }

    ${({$selected, theme}) => $selected && `
        border-${theme.rtl ? 'right' : 'left'}: var(--space-xs) solid var(--color-border-brand);
    `}

    &:hover:not(:disabled) {
        background: var(--color-brand-selected);
    }

    &:disabled {
        cursor: default;
    }
`;

export const label = styled.span<{$selected?: boolean}>`
    flex: 1;
    font-size: var(--font-size-body);
    line-height: var(--line-height-body, 1.4);
    color: var(--color-text-default);
    font-weight: ${({$selected}) =>
    $selected ? 'var(--font-weight-bold)' : 'var(--font-weight-regular)'};
`;

export const badge = styled.span<{$variant: 'success' | 'error'}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--space-xs) var(--space-sm);
    border-radius: var(--radius-sm);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-semibold);
    line-height: var(--dimension-4, 16px);
    white-space: nowrap;

    background: ${({$variant}) =>
    $variant === 'success' ? 'var(--primitive-green-200)' : 'var(--color-state-error-bg)'};
    color: ${({$variant}) =>
        $variant === 'success' ? 'var(--color-state-success-main)' : 'var(--color-state-error-main)'};
`;
